import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { industries } from '../data/industries';
import './Industries.css';

const Industries = ({ eyebrow = 'Who we serve', title, lead }) => {
  return (
    <section className="industries section section--alt">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">{eyebrow}</span>
          <h2 className="section-title section-title--center">
            {title || (
              <>
                Built for the industries that <span className="gradient-text">need software the most</span>.
              </>
            )}
          </h2>
          <p className="section-lead section-lead--center">
            {lead ||
              'Five focus industries where we have shipped real products and know the workflows, the regulations and the buyer.'}
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((i) => {
            const Icon = i.icon;
            return (
              <Link
                key={i.slug}
                to={`/industries/${i.slug}`}
                className="industry-card"
                style={{ '--ind-accent': i.accent }}
              >
                <div className="industry-icon"><Icon /></div>
                <h3 dangerouslySetInnerHTML={{ __html: i.title }} />
                <p>{i.short}</p>
                <span className="industry-link">
                  Read more <FiArrowRight />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
